import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  storageBinProcessFetchStorageBinProcess: null,
  storageBinProcessFetchStorageBinProcessLoading: ['boolean'],
  storageBinProcessFetchStorageBinProcessSuccess: ['process']
});

export const StorageBinProcessTypes = Types;
export default Creators;
